import { Component, input } from '@angular/core';
import type { OnyxDate } from '@onyx/angular';
import { OnyxDatePipe, OnyxIconComponent } from '@onyx/angular';

@Component({
  selector: 'app-unavailability-range-cell',
  imports: [OnyxIconComponent, OnyxDatePipe],
  templateUrl: './unavailability-range-cell.component.html',
  styleUrl: './unavailability-range-cell.component.scss',
})
export class UnavailabilityRangeCellComponent {
  public readonly range = input.required<OnyxDate | null>();
}
